export const PEOPLE = 'PEOPLE'
export const CHAT = 'CHAT'
export const MICROPHONE = 'MICROPHONE'
export const HAND = 'HAND'
export const LEAVE_ROOM = 'LEAVE_ROOM'
